import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-assets",
  "use": "icon-assets-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-assets\"><path fill=\"#bfcbd9\" d=\"M469.4016 512.068267a25.6 25.6 0 1 0 0 51.2h119.466667a25.6 25.6 0 0 0 0-51.2h-119.466667z\" /><path fill=\"#bfcbd9\" d=\"M204.868267 225.348267h614.4a81.92 81.92 0 0 1 81.92 81.92v68.266666c0 27.409067-13.482667 51.643733-34.133334 66.56v240.64a116.053333 116.053333 0 0 1-116.053333 116.053334h-477.866667a116.053333 116.053333 0 0 1-116.053333-116.053334v-240.64a81.8176 81.8176 0 0 1-34.133333-66.56v-68.266666a81.92 81.92 0 0 1 81.92-81.92z m614.4 232.106666h-614.4v225.28a68.266667 68.266667 0 0 0 68.266666 68.266667h477.866667a68.266667 68.266667 0 0 0 68.266667-68.266667v-225.28z m34.133333-81.92v-68.266666a34.133333 34.133333 0 0 0-34.133333-34.133334h-614.4a34.133333 34.133333 0 0 0-34.133334 34.133334v68.266666c0 7.68 2.525867 14.7456 6.826667 20.48h669.013333a33.962667 33.962667 0 0 0 6.826667-20.48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/assets.svg
// module id = 7tfs
// module chunks = 132